import ServiceRate from "./ServiceRate";
export default ServiceRate;
